module.exports = __webpack_public_path__ + "static/media/3411109.cfac5e91.jpg";